import type { RobotStatusDto, RunStatsDto } from '@brickup/shared/dto'
import { cronJobApi } from './cron-job'

let socketOpen = false

/** Called by the robot's socket as it connects and drops: while it is open,
 *  the runs it reports keep the status entry current. */
export function setRobotSocketOpen(open: boolean): void {
  socketOpen = open
}

/** The matching robot as a scheduled job. Its runs are reported over a
 *  socket, which writes `running` into the status entry, so the status is
 *  polled during a run only while no socket is open. */
export const robotJob = cronJobApi<RobotStatusDto, RunStatsDto>(
  'matching-robot',
  {
    status: '/matching/robot/status',
    config: '/matching/robot/config',
    trigger: '/matching/robot/run',
  },
  { pushed: () => socketOpen },
)

/** The cache entry of the robot's status. */
export const ROBOT_STATUS_KEY = robotJob.statusKey
export const fetchRobotStatus = robotJob.fetchStatus
